import httpRequest from 'httpRequest'
import { ModuleActionContract, PermissionContract } from 'models'

const COMPANY_PERMISSION_PREFIX = '/company/permissions'
const LOCATION_PERMISSION_PREFIX = '/location/permissions'

const permissionService = {
    getPermissionOfCurrentUser: () =>
        httpRequest.get<ModuleActionContract[]>(
            `${COMPANY_PERMISSION_PREFIX}/current-user`,
        ),
    fetchModulesAction: () =>
        httpRequest.get<ModuleActionContract[]>(`${COMPANY_PERMISSION_PREFIX}`),
    fetchModuleActionFromPin: (pin: string) =>
        httpRequest.get<PermissionContract[]>(
            `${LOCATION_PERMISSION_PREFIX}/users`,
            {
                params: {
                    pin,
                },
            },
        ),
}

export default permissionService
